import { z } from "zod";
import { ValidationMethods } from "../utility/validationMethods";
export var userAccountManagementFlyOutSchema = z.object({
    firstName: z.string().trim().min(2, "First name is required.").refine(function (value) { return ValidationMethods.isValidName(value); }, "First name can only include letters, spaces, periods, apostrophes, and hyphens."),
    lastName: z.string().trim().min(2, "Last name is required.").refine(function (value) { return ValidationMethods.isValidName(value); }, "Last name can only include letters, spaces, periods, apostrophes, and hyphens."),
    email: z.string().trim().email("Enter a valid email address."),
    phone: z.string()
        .trim()
        .min(1, "Phone number is required.")
        .refine(function (value) { return ValidationMethods.isValidPhoneNumber(value) && ValidationMethods.hasValidPhoneAreaCode(value); }, "Please enter a valid phone number."),
});
